// @ts-nocheck
import { MOCK } from "@/state/app-store";
import { UI } from "@/components/ui";
import { Icon } from "@/components/icons";
import { api } from "@/api/index";

const { $, $$, fmtNum, fmtMoney, fmtPercent, toast, confirmModal, hasPerm, statusBadge, trendArrow, statCard, channelChip, capabilityBadge, pageHeader, emptyState, primaryBtn, ghostBtn, stepIndicator, BUSINESS_COLORS, chartTooltip, chartXAxis, chartYAxis, chartLineSeries, chartBarSeries } = UI;

declare const echarts: any;
declare const Pages: Record<string, any>;
declare const PageHooks: { mounted?: ((path: string) => void) | null };
declare function navigate(path: string): void;
declare function getCurrentPath(): string;
declare function getCurrentPathWithQuery(): string;
declare function renderRoute(): void;

if (typeof window !== "undefined") {
  (window as any).Pages = (window as any).Pages || {};
}

const Pages = (window as any).Pages;

// __legacy_global_aliases__
// Resolve cross-module helpers via window (legacy SPA globals)
const configId = (...args: any[]) => (window as any).configId(...args);
const getLandingPage = (...args: any[]) => (window as any).getLandingPage(...args);
const renderOpsModuleTabs = (...args: any[]) => (window as any).renderOpsModuleTabs(...args);
const renderOpsWorkflowHint = (...args: any[]) => (window as any).renderOpsWorkflowHint(...args);


// ============================================================
// 运营管理 · 分享管理 / 数据分析中心
// ============================================================

window.Pages = window.Pages || {};

// ---------- 分享管理（实时分享流水查询） ----------
Pages.shareManager = function () {
  return `
    ${UI.pageHeader({
      title: "分享管理",
      desc: "查看每一笔分享流水、分享来源、活动配置与归因结果。",
      actions: `
        <button onclick="UI.toast('已批量复制选中链接', 'success')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">批量复制</button>
        <button onclick="UI.toast('开始导出', 'info')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">导出</button>
      `,
    })}
    ${renderOpsModuleTabs("share")}
    ${renderOpsWorkflowHint("share")}

    <!-- 概览 -->
    <div class="grid grid-cols-5 gap-4 mb-4">
      ${UI.statCard({ label: "今日分享次数", value: UI.fmtNum(26366), delta: 12, icon: "📤", color: "brand" })}
      ${UI.statCard({ label: "已转化分享", value: UI.fmtNum(7825), delta: 18, icon: "✅", color: "green" })}
      ${UI.statCard({ label: "失败分享", value: 312, delta: -8, icon: "❌", color: "rose" })}
      ${UI.statCard({ label: "活跃 分享码", value: UI.fmtNum(18432), delta: 5, icon: "🔗", color: "blue" })}
      ${UI.statCard({ label: "平均归因时长", value: "23 分钟", delta: 0, icon: "⏱", color: "amber" })}
    </div>

    <div class="card p-4 mb-4 bg-ink-50/70">
      <div class="grid grid-cols-4 gap-3 text-xs">
        <div class="rounded-lg bg-white border border-ink-100 p-3"><div class="font-semibold text-ink-900">上游来源</div><div class="text-ink-500 mt-1">落地页 / 卡片 / 活动配置共同生成分享实例</div></div>
        <div class="rounded-lg bg-white border border-ink-100 p-3"><div class="font-semibold text-ink-900">运行时参数</div><div class="text-ink-500 mt-1">活动配置 + 卡片 + 落地页</div></div>
        <div class="rounded-lg bg-white border border-ink-100 p-3"><div class="font-semibold text-ink-900">归因主键</div><div class="text-ink-500 mt-1 font-mono">分享码 / target_url</div></div>
        <div class="rounded-lg bg-white border border-ink-100 p-3"><div class="font-semibold text-ink-900">下游分析</div><div class="text-ink-500 mt-1">点击路径可进入数据分析查看漏斗明细</div></div>
      </div>
    </div>

    <!-- 筛选器 -->
    <div class="card p-4 mb-4 flex items-center gap-3 flex-wrap">
      <div class="flex items-center gap-2">
        <span class="text-xs text-ink-500">时间</span>
        <select class="text-sm border border-ink-100 rounded-lg px-2.5 py-1.5 bg-white">
          <option>今天</option>
          <option>最近 24 小时</option>
          <option>最近 7 天</option>
          <option>自定义</option>
        </select>
      </div>
      <div class="flex items-center gap-2">
        <span class="text-xs text-ink-500">游戏</span>
        <select class="text-sm border border-ink-100 rounded-lg px-2.5 py-1.5 bg-white">
          <option>全部</option>
          ${MOCK.GAMES.map((g) => `<option>${g.name}</option>`).join("")}
        </select>
      </div>
      <div class="flex items-center gap-2">
        <span class="text-xs text-ink-500">渠道</span>
        <select class="text-sm border border-ink-100 rounded-lg px-2.5 py-1.5 bg-white">
          <option>全部</option>
          ${MOCK.CHANNELS.filter((c) => c.enabled).map((c) => `<option>${c.icon} ${c.name}</option>`).join("")}
        </select>
      </div>
      <div class="flex items-center gap-2">
        <span class="text-xs text-ink-500">状态</span>
        <select class="text-sm border border-ink-100 rounded-lg px-2.5 py-1.5 bg-white">
          <option>全部</option>
          <option>已完成</option>
          <option>失败</option>
          <option>已过期</option>
        </select>
      </div>
      <div class="flex items-center gap-2">
        <span class="text-xs text-ink-500">活动配置</span>
        <select class="text-sm border border-ink-100 rounded-lg px-2.5 py-1.5 bg-white">
          <option>全部</option>
          ${[...new Set(MOCK.SHARE_RECORDS.map((s) => s.config_id))].map((id) => `<option>${id}</option>`).join("")}
        </select>
      </div>
      <div class="flex items-center gap-2">
        <span class="text-xs text-ink-500">最深漏斗层</span>
        <select class="text-sm border border-ink-100 rounded-lg px-2.5 py-1.5 bg-white">
          <option>全部</option>
          ${MOCK.FUNNEL_LEVELS.map((l) => `<option>${l.name}</option>`).join("")}
        </select>
      </div>
      <div class="flex-1"></div>
      <input type="text" placeholder="分享码 / 分享者 / 活动 / 卡片 / 落地页" class="w-72 text-xs border border-ink-100 rounded-lg px-3 py-1.5" />
    </div>

    <!-- 分享流水表 -->
    <div class="card overflow-hidden">
      <table class="w-full text-sm">
        <thead class="bg-ink-50 text-xs text-ink-500">
          <tr>
            <th class="text-left px-3 py-2.5 font-medium w-8"><input type="checkbox" class="w-3.5 h-3.5 rounded" /></th>
            <th class="text-left px-3 py-2.5 font-medium">分享时间</th>
            <th class="text-left px-3 py-2.5 font-medium">游戏 / 包体</th>
            <th class="text-left px-3 py-2.5 font-medium">渠道</th>
            <th class="text-left px-3 py-2.5 font-medium">分享者</th>
            <th class="text-left px-3 py-2.5 font-medium">活动 / 卡片 / 落地页</th>
            <th class="text-left px-3 py-2.5 font-medium">分享码</th>
            <th class="text-left px-3 py-2.5 font-medium">状态</th>
            <th class="text-left px-3 py-2.5 font-medium">最深层级</th>
            <th class="text-right px-3 py-2.5 font-medium">价值</th>
            <th class="text-right px-3 py-2.5 font-medium">操作</th>
          </tr>
        </thead>
        <tbody>
          ${MOCK.SHARE_RECORDS.map((s) => {
            const c = MOCK.CHANNELS.find((x) => x.code === s.channel);
            const lv = MOCK.FUNNEL_LEVELS.find((x) => x.code === s.funnel);
            const statusMap = {
              completed: { text: "已完成", color: "bg-emerald-50 text-emerald-700" },
              failed: { text: "失败", color: "bg-red-50 text-red-700" },
              expired: { text: "已过期", color: "bg-ink-100 text-ink-500" },
            };
            const st = statusMap[s.status];
            const game = MOCK.GAMES.find((g) => g.name === s.game);
            const cfg = (MOCK.SHARE_CONFIGS || []).find((item) => configId(item) === s.config_id);
            const landingPage = getLandingPage(s.landing_page_id);
            return `
            <tr class="border-t border-ink-100 row-hover">
              <td class="px-3 py-2.5"><input type="checkbox" class="w-3.5 h-3.5 rounded" /></td>
              <td class="px-3 py-2.5 text-xs text-ink-500 font-mono">${s.time}</td>
              <td class="px-3 py-2.5">
                <div class="flex items-center gap-1 text-xs">
                  <span>${game?.icon || ""}</span>
                  <span>${s.game}</span>
                  <span class="text-ink-300">/</span>
                  <span class="text-ink-500">${s.pkg}</span>
                </div>
              </td>
              <td class="px-3 py-2.5"><span class="text-base mr-1">${c?.icon || "🔗"}</span>${c?.name || s.channel}</td>
              <td class="px-3 py-2.5 font-mono text-[11px] text-ink-500">${s.sharer}</td>
              <td class="px-3 py-2.5 min-w-[220px]">
                <div class="text-xs font-medium text-ink-900 line-clamp-1">${cfg?.name || s.config_id || "默认活动配置"}</div>
                <div class="mt-1 flex flex-wrap gap-1">
                  <span class="badge bg-brand-50 text-brand-700">${cfg?.title || "分享卡片"}</span>
                  <span class="badge ${s.landing_source === "url" ? "bg-purple-50 text-purple-700" : s.landing_source === "default" ? "bg-ink-100 text-ink-600" : "bg-purple-50 text-purple-700"}">${landingPage?.name || "默认落地页"}</span>
                </div>
              </td>
              <td class="px-3 py-2.5"><code class="px-1.5 py-0.5 bg-ink-50 rounded text-[10px] font-mono text-ink-700">${s.refCode}</code></td>
              <td class="px-3 py-2.5">
                <span class="badge ${st.color}">${st.text}</span>
                ${s.error ? `<div class="text-[10px] text-red-500 mt-0.5">${s.error}</div>` : ""}
              </td>
              <td class="px-3 py-2.5">
                <span class="badge bg-blue-50 text-blue-700">${lv?.name || s.funnel}</span>
              </td>
              <td class="px-3 py-2.5 text-right ${s.value > 0 ? "text-emerald-600 font-semibold" : "text-ink-300"}">${s.value > 0 ? UI.fmtMoney(s.value) : "—"}</td>
              <td class="px-3 py-2.5 text-right">
                <button onclick="navigate('/ops/analytics/paths')" class="text-[11px] text-brand-500 hover:underline mr-1">路径</button>
                <button class="text-[11px] text-ink-500 hover:underline">复制</button>
              </td>
            </tr>`;
          }).join("")}
        </tbody>
      </table>
      <div class="px-4 py-3 border-t border-ink-100 flex items-center justify-between text-xs text-ink-500">
        <div>共 <strong>26,366</strong> 条记录 · 显示 1-10</div>
        <div class="flex items-center gap-1">
          <button class="px-2 py-1 rounded hover:bg-ink-50">‹</button>
          <button class="px-2 py-1 rounded bg-brand-500 text-white">1</button>
          <button class="px-2 py-1 rounded hover:bg-ink-50">2</button>
          <button class="px-2 py-1 rounded hover:bg-ink-50">3</button>
          <span class="px-1">…</span>
          <button class="px-2 py-1 rounded hover:bg-ink-50">2637</button>
          <button class="px-2 py-1 rounded hover:bg-ink-50">›</button>
        </div>
      </div>
    </div>
  `;
};

// ---------- 数据分析中心（4 个子分析的 Tab/卡片入口） ----------
Pages.analyticsHub = function () {
  return `
    ${UI.pageHeader({
      title: "数据分析",
      desc: "围绕分享活动、渠道、用户路径和收入转化做运营复盘，支持从 分享码 追踪完整链路。",
      actions: `<button onclick="navigate('/ops/analytics/export')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">数据导出</button>`,
    })}
    ${renderOpsModuleTabs("analytics")}
    ${renderOpsWorkflowHint("analytics")}

    <!-- 关键指标速览 -->
    <div class="grid grid-cols-4 gap-4 mb-6">
      ${UI.statCard({ label: "近 7 天总分享", value: UI.fmtNum(184320), delta: 14, icon: "📤", color: "brand" })}
      ${UI.statCard({ label: "近 7 天总转化", value: "1.83%", delta: 8, icon: "📈", color: "green" })}
      ${UI.statCard({ label: "近 7 天总收入", value: UI.fmtMoney(184560), delta: 22, icon: "💰", color: "amber" })}
      ${UI.statCard({ label: "异常预警", value: "1 项", delta: 0, icon: "⚠️", color: "rose" })}
    </div>

    <!-- 4 个分析维度卡片 -->
    <div class="grid grid-cols-2 gap-4 mb-6">
      ${[
        { title: "漏斗分析", desc: "8 层完整漏斗追踪：分享 → 送达 → 展示 → 点击 → 下载 → 安装 → 注册 → 教程 → 付费", path: "/ops/analytics/funnel", icon: "🔻", color: "from-brand-400 to-brand-600", insight: "最大流失点：点击 → 下载 (流失 70%)" },
        { title: "渠道对比", desc: "各渠道分享量、点击率、CPI、ROI 的横向对比，找出最优渠道", path: "/ops/analytics/channels", icon: "🌐", color: "from-emerald-400 to-emerald-600", insight: "🏆 Discord 当前 ROI 最高 520%" },
        { title: "趋势分析", desc: "时间维度的数据走势、环比对比、异常自动预警", path: "/ops/analytics/trends", icon: "📈", color: "from-amber-400 to-amber-600", insight: "⚠️ Facebook 转化率 24h 内 -35%" },
        { title: "用户路径", desc: "通过 分享码 串联单个用户从分享到付费的完整链路", path: "/ops/analytics/paths", icon: "🔗", color: "from-rose-400 to-rose-600", insight: "示例：分享 → 注册耗时 ~20 分钟" },
      ]
        .map(
          (m) => `
        <div onclick="navigate('${m.path}')" class="card overflow-hidden hover:shadow-pop transition cursor-pointer group">
          <div class="h-20 bg-ink-100 flex items-center px-5 relative">
            <div class="text-3xl mr-3">${m.icon}</div>
            <div class="text-white">
              <div class="text-base font-bold">${m.title}</div>
              <div class="text-xs opacity-80 mt-0.5">${m.desc.split("，")[0]}</div>
            </div>
            <div class="absolute right-4 text-2xl text-white/70 group-hover:translate-x-1 transition">→</div>
          </div>
          <div class="p-4">
            <div class="text-xs text-ink-500">${m.desc}</div>
            <div class="mt-3 px-3 py-2 bg-ink-50 rounded text-xs text-ink-700">
              💡 ${m.insight}
            </div>
          </div>
        </div>`,
        )
        .join("")}
    </div>

    <!-- 报表预设 -->
    <div class="card p-5">
      <div class="flex items-center justify-between mb-3">
        <h3 class="text-sm font-semibold text-ink-900">📑 我的报表预设</h3>
        <button class="text-xs text-brand-500 hover:underline">+ 创建预设</button>
      </div>
      <div class="grid grid-cols-3 gap-3">
        ${[
          { name: "周报：王者征途渠道对比", desc: "每周一 09:00 自动发邮件", time: "上次：5/13 09:00", color: "brand" },
          { name: "月报：全游戏漏斗", desc: "每月 1 号生成 PDF", time: "上次：5/01 10:00", color: "green" },
          { name: "实时：Facebook 转化告警", desc: "异常时邮件 + 站内信", time: "已触发 2 次", color: "amber" },
        ]
          .map(
            (r) => `
          <div class="border border-ink-100 rounded-lg p-3 hover:border-brand-300 cursor-pointer">
            <div class="text-sm font-medium text-ink-900">${r.name}</div>
            <div class="text-xs text-ink-500 mt-1">${r.desc}</div>
            <div class="text-[10px] text-ink-300 mt-2">${r.time}</div>
          </div>
        `,
          )
          .join("")}
      </div>
    </div>
  `;
};

// __window_exports__
// Expose helpers for cross-page / inline onclick compatibility
